import createStripeSubscriptionAction from "@actions/createStripeSubscriptionAction"
import completePaymentLoader from "@loaders/completePaymentLoader"
import getPricesLoader from "@loaders/getPricesLoader"
import getUserLoader from "@loaders/getUserLoader"
import GiftPage from "@pages/checkout/GiftPage"
import PaymentCompletionPage from "@pages/checkout/PaymentCompletionPage"
import PaymentPage from "@pages/checkout/PaymentPage"
import PlansPageRouter from "@pages/checkout/PlansPageRouter"
import { Navigate, Outlet } from "react-router-dom"

const checkoutRoutes = [
  {
    element: <Outlet />,
    loader: getUserLoader,
    path: "/checkout",
    children: [
      {
        index: true,
        element: <Navigate to="plans" replace />,
      },
      {
        element: <PaymentPage />,
        loader: getUserLoader,
        path: "payment",
      },
      {
        element: <PaymentCompletionPage />,
        loader: completePaymentLoader,
        path: "payment-completion",
      },
      {
        action: createStripeSubscriptionAction,
        element: <PlansPageRouter />,
        loader: getPricesLoader,
        path: "plans",
      },
      {
        element: <GiftPage />,
        path: "gift",
      },
      {
        element: <Navigate to="/checkout/gift" replace />,
        path: "upsell",
      },
    ],
  },
]

export default checkoutRoutes
